<template>
  <div v-if="isLoading" class="flex items-center gap-1">
    <at-skeleton class="w-6" style="max-height: 1.5rem" />
    <at-skeleton class="w-24" style="max-height: 1.5rem" />
  </div>

  <div v-else class="whitespace-normal flex items-center gap-1">
    <currency-dollar-icon class="text-gray-400 dark:text-gray-500 h-6 w-6" />
    <p class="leading-4 text-gray-600 dark:text-gray-400 font-medium text-sm">
      {{ formatPrice(limit.current_amount, { fraction: 0 }) }}
    </p>
  </div>
</template>

<script setup>
  import { CurrencyDollarIcon } from '@heroicons/vue/solid';

  import { formatPrice } from '@/to-fsd/shared/lib';

  import { AtSkeleton } from '@packages/aliftech-ui';

  defineProps({
    isLoading: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Object,
      default: null,
    },
  });
</script>
